import { useCallback, useRef, useState } from 'react';
import { ROUTING_MAP } from '../routes';

export const useHelpCenterTarget = (pathname) => {
  const [target, setTarget] = useState(null);
  const isTargetDefinedRef = useRef(!!target);

  const clearTarget = useCallback(() => {
    if (isTargetDefinedRef.current) {
      setTarget(null);
    }
  }, [setTarget]);

  const findHelpCenterTarget = useCallback(() => {
    const currentHelpCenterRoutes = Object.values(ROUTING_MAP);

    return (
      currentHelpCenterRoutes.find((value) => {
        const routingSectionRegExp = new RegExp(`(^${value})[^/]*(\\/)?$`);

        return routingSectionRegExp.test(pathname);
      }) || ROUTING_MAP.underConstruction
    );
  }, [pathname]);

  const setTargetValue = useCallback(
    (target) => {
      const targetValue = target || findHelpCenterTarget();
      isTargetDefinedRef.current = !!targetValue;

      setTarget(targetValue);
    },
    [setTarget, findHelpCenterTarget],
  );

  return {
    target,
    setTarget: setTargetValue,
    clearTarget,
  };
};
